import { render, staticRenderFns } from "./LocationSearch.vue?vue&type=template&id=161a9d04&scoped=true"
import script from "./LocationSearch.vue?vue&type=script&lang=ts"
export * from "./LocationSearch.vue?vue&type=script&lang=ts"
import style0 from "./LocationSearch.vue?vue&type=style&index=0&id=161a9d04&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161a9d04",
  null
  
)

export default component.exports